<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';

    defineOptions({
        inheritAttrs: false,
    });

    interface Props {
        className?: HTMLAttributes['class'];
    }

    defineProps<Props>();
</script>

<template>
    <svg
        viewBox="0 0 19 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="className"
    >
        <path
            d="M17.5 13.8315V6.49812C17.4997 6.17662 17.4148 5.86086 17.2539 5.58252C17.093 5.30418 16.8618 5.07304 16.5833 4.91229L10.1667 1.24562C9.88796 1.08471 9.57182 1 9.25 1C8.92818 1 8.61204 1.08471 8.33333 1.24562L1.91667 4.91229C1.63824 5.07304 1.40698 5.30418 1.24609 5.58252C1.0852 5.86086 1.00033 6.17662 1 6.49812V13.8315C1.00033 14.153 1.0852 14.4687 1.24609 14.7471C1.40698 15.0254 1.63824 15.2565 1.91667 15.4173L8.33333 19.084C8.61204 19.2449 8.92818 19.3296 9.25 19.3296C9.57182 19.3296 9.88796 19.2449 10.1667 19.084L16.5833 15.4173C16.8618 15.2565 17.093 15.0254 17.2539 14.7471C17.4148 14.4687 17.4997 14.153 17.5 13.8315Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.24967 13.8314C11.2747 13.8314 12.9163 12.1898 12.9163 10.1647C12.9163 8.13967 11.2747 6.49805 9.24967 6.49805C7.22463 6.49805 5.58301 8.13967 5.58301 10.1647C5.58301 12.1898 7.22463 13.8314 9.24967 13.8314Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
